<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :is-row-selectable="isRowSelectable"
        row-selection="single"
        :auto-select-first-row="false"
        :rows="rows"
        class="agGrid"
        :auto-size-cell="true"
        @rowClicked="isRowSelected = true"
        @refresh="onRefresh"
      />
    </div>

    <div class="button-containers">
      <button
        :disabled="!isRowSelected"
        class="btn primary small outline"
        @click="deleteShift"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="!isRowSelected"
        class="btn primary small"
        @click="openEditFormDialog"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="openAddViewDialog">
        {{ $t('button.add') }}
      </button>
    </div>

    <el-dialog
      :title="!isEdit ? 'Thêm ca' : 'Sửa ca'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Mã</div>
                  <validation-provider rules="required" name="Mã">
                    <div>
                      <input v-model="submitForm.code" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Giờ bắt đầu</div>
                  <validation-provider rules="required" name="Giờ bắt đầu">
                    <div class="child-w-80">
                      <el-time-picker
                        v-model="submitForm.start_hour"
                        format="HH:mm"
                        value-format="HH:mm"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Giờ kết thúc</div>
                  <validation-provider rules="required" name="Giờ kết thúc">
                    <div class="child-w-80">
                      <el-time-picker
                        v-model="submitForm.end_hour"
                        format="HH:mm"
                        value-format="HH:mm"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tên ca tiếng Việt</div>
                  <validation-provider
                    rules="required|max:20"
                    name="Tên ca tiếng Việt"
                  >
                    <div class="child-w-80">
                      <input v-model="submitForm.name" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tên ca tiếng Anh</div>
                  <validation-provider
                    rules="required|max:20"
                    name="Tên ca tiếng Anh"
                  >
                    <div class="child-w-80">
                      <input v-model="submitForm.eng_name" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Mô tả</div>
                  <validation-provider rules="required|max:255" name="Mô tả">
                    <div class="child-w-80">
                      <textarea
                        v-model="submitForm.description"
                        style="width: 100%"
                        rows="4"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn outline primary small"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button v-if="isEdit" class="btn primary small" @click="updateShift">
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addShift">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'
import {
  addShiftApi,
  deleteShiftApi,
  getShiftByIdApi,
  getListShiftApi,
  updateShiftApi
} from '@/api/configuration/hotel/shift.js'
export default {
  data() {
    return {
      isRowSelected: false,
      loading: false,
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      businessDistrictList: [],
      submitForm: {
        name: '',
        eng_name: '',
        start_hour: '',
        end_hour: '',
        description: ''
      },
      // isRowSelectable: node => !node.data.isFullWidthRow,

      columns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        // },
        {
          headerName: 'Mã ca',
          field: 'id',
          // cellClass: "grid-cell-centered",
          maxWidth: 150,
          tooltipField: 'id',
          sortable: false
        },
        {
          headerName: 'Tên ca tiếng Việt',
          maxWidth: 200,
          field: 'name',
          tooltipField: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Tên ca tiếng Anh',
          field: 'eng_name',
          tooltipField: 'eng_name',
          maxWidth: 200,
          sortable: false
        },
        {
          headerName: 'Giờ bắt đầu',
          field: 'start_hour',
          maxWidth: 150,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Giờ kết thúc',
          maxWidth: 150,
          field: 'end_hour',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Mô tả',
          field: 'description',
          tooltipField: 'description',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.$nullValueInObj(this.submitForm)
    }
  },

  mounted() {
    this.attachData()
  },

  methods: {
    onRefresh(data) {
      let params = {
        order_by: data.orderBy,
        order_tp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },

    async attachData() {
      this.loading = true
      let data = await getListShiftApi()
      this.isRowSelected = false
      this.loading = false
      this.rows = data.data
    },
    async addShift() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await addShiftApi(this.submitForm)
      this.dialogFormVisible = false
      this.$message({
        type: 'success',
        message: 'Bạn đã thêm ca thành công'
      })
      this.attachData()
    },

    async updateShift() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await updateShiftApi(this.submitForm)
      this.dialogFormVisible = false
      this.$message({
        type: 'success',
        message: 'Bạn đã cập nhật ca thành công'
      })
      this.attachData()
    },

    async deleteShift() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      this.$vxConfirm('Bạn chắc chắn muốn xoá ca này?', async () => {
        await deleteShiftApi({
          ids: id_list
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    openAddViewDialog() {
      this.dialogFormVisible = true
      this.isEdit = false
    },
    openEditFormDialog() {
      const gridApi = this.$refs.agGrid.gridApi
      const selectedRow = gridApi.getSelectedRows()[0]
      Object.assign(this.submitForm, selectedRow)
      this.dialogFormVisible = true
      this.isEdit = true
    },
    async updateSubmitForm() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      this.isEdit = true
      let data = await getShiftByIdApi(rowsSelected[0].id)
      this.submitForm = { ...data.data }
      this.dialogFormVisible = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
